import { render, staticRenderFns } from "./RoleAuth.vue?vue&type=template&id=36a5806e&"
import script from "./RoleAuth.vue?vue&type=script&lang=js&"
export * from "./RoleAuth.vue?vue&type=script&lang=js&"
import style0 from "./RoleAuth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports